import { createStore } from 'vuex';
import master from '@master/store/index';
import insightRoot from '@insight/index';
import experienceRoot from '@experience/index';
import landingpage from '@landingPage/store/index';

export default createStore({
    modules: {
        master,
        insight: insightRoot.store,
        experience: experienceRoot.store,
        landingpage
    }
});
